import React from 'react';
import Breadcrumb from '../components/Breadcrumb';
import Datenschutz from '../components/Datenschutz';
import StructuredData, { breadcrumbStructuredData } from '../components/StructuredData';
import { usePageMeta } from '../hooks/usePageMeta';

const DatenschutzPage: React.FC = () => {
  usePageMeta({
    title: 'Datenschutzerklärung | Flugsportverein Otto Lilienthal Bad Langensalza e.V.',
    description: 'Datenschutzerklärung des Flugsportvereins Otto Lilienthal Bad Langensalza e.V.: Informationen zur Verarbeitung personenbezogener Daten, Cookies und externen Inhalten.',
    path: '/datenschutz',
  });

  return (
    <div className="min-h-screen bg-gray-50">
      <StructuredData data={breadcrumbStructuredData('Datenschutzerklärung', '/datenschutz')} />
      <Breadcrumb currentPage="Datenschutzerklärung" />
      <Datenschutz />
    </div>
  );
};

export default DatenschutzPage;
